export * from './groups.service';
import { GroupsService } from './groups.service';
export * from './jwt.service';
import { JwtService } from './jwt.service';
export * from './userSettings.service';
import { UserSettingsService } from './userSettings.service';
export const APIS = [GroupsService, JwtService, UserSettingsService];
